import template from './idSmartButton.template.html';

export default {
  template,
  bindings: {
    owner: '<',
    idTicket: '<',
    idClients: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, idSmartService, contactsService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isOpenDialog = false;
      ctrl.$mdMedia = $mdMedia;
      ctrl.isAnyClientInvited = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = async () => {
        ctrl.contacts = await contactsService.getSpecific({
          idContacts: ctrl.idClients,
          isActive: true
        });
        ctrl.contacts = _.sortBy(ctrl.contacts, (c) => _.indexOf(ctrl.idClients, c.id));
        ctrl.isAnyClientInvited = ctrl.contacts.some((contact) =>
          _.get(contact, 'verificationScore.idSmart.invited')
        );
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
      };

      this.openDialog = () => {
        ctrl.isOpenDialog = true;
      };

      this.send = async ($event, contact) => {
        $event.stopPropagation();
        const res = await idSmartService.send({
          idContact: contact.id,
          idTicket: ctrl.idTicket
        });

        if (res.status) {
          uiService.toast({
            text: {
              p1: 'IDsmart',
              p2: 'invitation',
              p3: 'sent successfully'
            },
            success: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'IDsmart invitation',
              p2: 'failed',
              p3: res.errorMessage
            },
            warn: true
          });
        }

        ctrl.onFinished({ status: true });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };
      this.$onChanges = () => {
        ctrl.initialize();
      };
    }
  }
};
